import { useEffect, useRef, useState } from "react";

import { useTranslation } from "react-i18next";
import "../General.css";
import "primeicons/primeicons.css";

import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import AdminDialog from "./AdminDialog/AdminDialog";
import AdminPageHeader from "./AdminPageHeader";
import { getAllusersService } from "../../services/User/UsersServices";
import { getAllCompaniesService } from "../../services/Company/CompanyServices";
import { getAllproductsService } from "../../services/Product/ProductServices";
import { getAllordersService } from "../../services/Order/OrderServices";

interface EntityCounts {
  users?: number;
  companies?: number;
  products?: number;
  orders?: number;
}

const AdminDashboard = () => {
  const { t } = useTranslation(["common", "signin"]);
  const [visible, setVisible] = useState<boolean>(false);
  const [verificationCode, setVerificationCode] = useState<string>();
  const [showAddAdmin, setShowAddAdmin] = useState<boolean>(false);
  const toast = useRef<Toast>(null);
  const [counts, setCounts] = useState<EntityCounts>({});

  useEffect(() => {
    getAllusersService()
      .then((res: any) => setCounts((c) => ({ ...c, users: res.data?.length })))
      .catch((err) => console.error(err));
    getAllCompaniesService()
      .then((res: any) =>
        setCounts((c) => ({ ...c, companies: res.data?.length }))
      )
      .catch((err) => console.error(err));
    getAllproductsService()
      .then((res: any) =>
        setCounts((c) => ({ ...c, products: res.data?.length }))
      )
      .catch((err) => console.error(err));
    getAllordersService()
      .then((res: any) => setCounts((c) => ({ ...c, orders: res.data?.length })))
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="admin-page">
      <Toast ref={toast} position="top-right" />
      <AdminPageHeader
        title={t("common:adminDashboard")}
        action={
          <Button className="general-button" onClick={() => setShowAddAdmin(true)}>
            {t("common:addAdmin")}
          </Button>
        }
      />

      <div className="admin-page-body">
        <div className="admin-stat-grid">
          <div className="admin-stat-card">
            <div className="admin-stat-label">{t("common:userList")}</div>
            <div className="admin-stat-value">{counts.users ?? "-"}</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">{t("common:companies")}</div>
            <div className="admin-stat-value">{counts.companies ?? "-"}</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">{t("common:products")}</div>
            <div className="admin-stat-value">{counts.products ?? "-"}</div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-label">{t("common:orders")}</div>
            <div className="admin-stat-value">{counts.orders ?? "-"}</div>
          </div>
        </div>
      </div>

      <AdminDialog
        visible={visible}
        setVisible={setVisible}
        verificationCode={verificationCode}
        setVerificationCode={setVerificationCode}
        showAddAdmin={showAddAdmin}
        setShowAddAdmin={setShowAddAdmin}
      />
    </div>
  );
};

export default AdminDashboard;
